export enum ActivitiesType {
   ALL = "ALL",
   FOLLOWING = "FOLLOWING",
   MY = "MY"
}
